import * as getStatic from '@backpackjs/core-nextjs/get-static';

import { Cart } from '@/snippets/cart';

export const getStaticProps = getStatic.props.settings;

function CartPage() {
  return (
    <div className="cart px-0 lg:px-12">
      <div className="m-auto lg:container">
        <Cart />
      </div>
    </div>
  );
}

export default CartPage;
